export const fieldNames = {
  priceData: 'priceData',
  paymentTypes: 'paymentTypes',
  paymentState: 'paymentStateId',
};
